import { Component } from '@theme/component';

/**
 * A custom element that manages a bundle picker.
 *
 * @template {import('@theme/component').Refs} [Refs = {}]
 *
 * @extends Component<Refs>
 */
export default class BundlePicker extends Component {
  #form= document.querySelectorAll('form[action*="cart/add" i]');
  #selections = [];
  #selectionNames = [];
  #variantIds = [];
  
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('click', this.bundleChanged.bind(this));

    for (let i = 0; i < this.#form.length; i++) {
      let btn = this.#form[i].querySelector('[ref="addToCartButton"]');
      if (btn)
        btn.disabled = true;
    }
  }

  /**
   * Handles the bundle change event.
   * @param {Event} event - The bundle change event.
   */
  bundleChanged(event) {
    if (!(event.target instanceof HTMLElement)) return;

    let option = event.target.closest('.product-color-picker__option');

    if (!option) return;

    option.closest('.product-color-picker__options').querySelectorAll('.product-color-picker__option')?.forEach((item) => item.classList.remove('product-color-picker__option--selected'));
    option.classList.add('product-color-picker__option--selected');

    this.#selections[option.dataset.index] = option.dataset.sku;
    this.#selectionNames[option.dataset.index] = option.dataset.name;
    this.#variantIds[option.dataset.index] = option.dataset.variantId;

    this.setValue('Val', this.#selectionNames.join(', '));
    this.setValue('_bundle_skus', this.#selections.join('|'));
    this.setValue('_bundle_variants', this.#variantIds.join('|'));

    const actualCount = this.#selections.filter(Boolean).length;
    
    const requiredCount = parseInt(this.dataset.size);

    const isComplete = actualCount === requiredCount;

    for (let i = 0; i < this.#form.length; i++) {
      let btn = this.#form[i].querySelector('[ref="addToCartButton"]');
      if (btn) {
        btn.disabled = !isComplete; 
        
        btn.style.opacity = isComplete ? '1' : '0.5';
        btn.style.cursor = isComplete ? 'pointer' : 'not-allowed';
      }
   }
  }

  setValue(name, value) {
    for (let i = 0; i < this.#form.length; i++) {
      let input = this.#form[i].querySelector('input[name="properties[' + name + ']"]');
      if (input)
        input.value = value;
      else {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = 'properties[' + name + ']';
        input.value = value;

        this.#form[i].appendChild(input);
      }
    }
  }
}

if (!customElements.get('bundle-picker')) {
  customElements.define('bundle-picker', BundlePicker);
}
